import { __decorate } from "tslib";
import { Vue, Component, Prop } from 'vue-property-decorator';
import geometryDrawer from '@blade/common-ui/geometry-drawer/src/pages/geometry-drawer.vue';
let DrawMap = class DrawMap extends Vue {
    width;
    height;
    zoneInDraw = null;
    visible = true;
    onEndDraw(geoType, pointsOffset) {
        this.$emit('draw', geoType, pointsOffset);
        // console.log(geoType, pointsOffset);
        //   if (pointsOffset.length === 0) {
        //     this.closeDrawer();
        //     return;
        //   }
        //   switch (geoType) {
        //     case 'polygon': {
        //       const { name, id } = this.zoneInDraw;
        //       const roiData = getBlankRoi(name, id);
        //       let vertices:Array<Vertices> = [];
        //       pointsOffset.forEach(point => {
        //         const { x, y } = this.map.clientToMapPosition(point.x, point.y);// x,y map组件的坐标系
        //         roiData.props.points.push([x, y, 0]);
        //         vertices.push(reconvertLocation(x, y, this.imageSize as Size));// 需要转, 传给后端的是比例
        //       });
        //       this.closeDrawer();
        //       this.onEndDrawCalLBack && this.onEndDrawCalLBack({ zoneId: id, roi: { vertices, name: name } }).then(() => {
        //         this.map.addElement(this.roiCollectionID, roiData);
        //       });
        //       break;
        //     }
        //     case 'line':
        //       break;
        //   }
    }
    closeDrawer() {
        this.visible = false;
    }
};
__decorate([
    Prop()
], DrawMap.prototype, "width", void 0);
__decorate([
    Prop()
], DrawMap.prototype, "height", void 0);
DrawMap = __decorate([
    Component({
        name: 'draw-map',
        components: { geometryDrawer }
    })
], DrawMap);
export default DrawMap;
